import { css } from 'styled-components';
import { convertToDarkerRgba } from './convertToDarkerRgba';
import { linkEffect } from './linkEffect';
export const linkEffectForChildren = ({ theme, }) => css `
  a {
    ${linkEffect}
    /* Needed to force the color */
    color: ${theme.colors.link} !important;

    &:hover {
      color: ${convertToDarkerRgba(theme.colors.link)} !important;
    }
  }
`;
//# sourceMappingURL=linkEffectForChildren.js.map